import {FormControl, InputLabel, MenuItem, Select, TextField} from "@mui/material";
import {Box} from "@mui/system";
import {FC} from "react";
import {ClimbingEventGroup} from "../../../../models/ClimbingEvent";
import {CompetitionUserData} from "../../../../models/UserClimbingEvent";
import {rangeToString, toDate} from "../../../../services/time/TimeService";
import {useTranslation} from "react-i18next";

interface Props {
  groups: ClimbingEventGroup[],
  competitionData: CompetitionUserData,
  handleCompetitionUpdate: (competitionData: CompetitionUserData) => void,

  collectUserData: boolean,
}

export const UpdateCompetitionData: FC<Props> = ({
                                                   groups,
                                                   competitionData,
                                                   handleCompetitionUpdate,
                                                   collectUserData
                                                 }) => {
  const {t} = useTranslation()
  const selectedGroupString = competitionData.group ? groupToString(competitionData.group) : t('event.selectGroup')
  return (
    <Box display="flex" justifyContent="center" flexDirection="column" gap="15px">
      <FormControl fullWidth>
        <InputLabel id="group-label">{t('event.group')}</InputLabel>
        <Select
          sx={{minWidth: 200}}
          labelId="group-label"
          id="user-group"
          value={competitionData.group?.id || 0}
          renderValue={(value) => selectedGroupString}
          label={t('event.group')}
          required={true}
          onChange={(e) => handleCompetitionUpdate({
            ...competitionData,
            group: groups.find(g => g.id === (e.target.value as number))
          })}
        >
          {groups
            .sort((a, b) => a.startDate - b.startDate)
            .map(group => <MenuItem key={"group_" + group.id} value={group.id}>{groupToString(group)}</MenuItem>)}
        </Select>
      </FormControl>
      {collectUserData &&
          <>
              <TextField
                  label={t('event.city')}
                  value={competitionData.city}
                  multiline
                  maxRows={3}
                  error={!competitionData.city}
                  required={true}
                  onChange={(e) => handleCompetitionUpdate({...competitionData, city: e.target.value})}/>

              <TextField
                  label={t('event.club')}
                  value={competitionData.sponsorName}
                  multiline
                  maxRows={3}
                  onChange={(e) => handleCompetitionUpdate({...competitionData, sponsorName: e.target.value})}/>
          </>
      }

    </Box>)
}
const groupToString = (group: ClimbingEventGroup) => group.name + " " + rangeToString(toDate(group.startDate), toDate(group.endDate))
